import { Abstrap } from '../..';

const { propTypes } = Abstrap;

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    style: {
        display: 'block',
    },
};

class TabMenuBottom extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-tab-menu__bottom',
            className,
        ];
    }

}

TabMenuBottom.propTypes = propTypes;

TabMenuBottom.defaultProps = defaultProps;

export default TabMenuBottom;
